module.exports = __webpack_public_path__ + "img/user_mng_yellow.359937a4.svg";